import React from 'react';
import ClassNames from 'classnames';
import Formatter from '../../utils/Formatter.js';
import DateTime from '../../utils/DateTime.js';
import UrlService from '../../services/UrlService';

const UserNotification = React.createClass({
    getInitialState: function () {
        return { count: 300, interval: undefined };
    },
    propTypes: {
        id: React.PropTypes.string.isRequired,
        messageHeader: React.PropTypes.string,
        message: React.PropTypes.string.isRequired,
        onClick: React.PropTypes.func,
        onClickButton: React.PropTypes.func,
        isHidden: React.PropTypes.bool.isRequired,
        hideIcon: React.PropTypes.bool,
        wrapCopy: React.PropTypes.bool,
        showButton: React.PropTypes.bool,
        buttonText: React.PropTypes.string,
        buttonClassName: React.PropTypes.string,
        className: React.PropTypes.string,
        messageClassName: React.PropTypes.string,
        isCountdown: React.PropTypes.bool,
        showBackButton: React.PropTypes.bool,
        onClickBackButton: React.PropTypes.func
    },
    defaultProps: {
        hideIcon: false,
        showButton: false,
        buttonText: 'OK',
        className: '',
        isCountdown: false,
        messageClassName: 'user-notification-msg',
        showBackButton: false
    },
    componentDidMount: function () {
        let interval;
        if (this.props.isCountdown && !this.props.isHidden && this.refs.userNotification) {
            interval = setInterval(this.timer, 1000);
            this.setState({ interval: interval });
        }
    },
    componentWillUnmount: function () {
        if (this.state.interval) {
            clearInterval(this.state.interval);
        }
    },
    timer: function () {
        let newCount = this.state.count - 1;
        if (this.refs.userNotification) {
            if (newCount >= 0) {
                this.setState({ count: this.state.count-1 });
            } else {
                clearInterval(this.state.interval);
                window.open(UrlService.getLogOffUrl(), '_self');
            }
        }
    },
    getMessageBody: function () {
        let message;

        if (!this.props.messageHeader) {
            return null;
        }

        if (this.props.isCountdown) {
            message = Formatter.formatString(this.props.message, {time: DateTime.convertSecondsToMMSS(this.state.count)});
            return <div className="row col-xs-12 user-notification-message-body"><p dangerouslySetInnerHTML={{ __html: message }}></p></div>;
        }
    },
    getMessageHeader: function () {
        let messageStyle = this.props.hideIcon ? 'no-icon' : '',
            message = this.props.messageHeader? this.props.messageHeader : this.props.message;

        return <p className={messageStyle} dangerouslySetInnerHTML={{ __html: message }}></p>;
    },
    render() {
        const iconStyle = this.props.hideIcon ? 'hidden' : 'col-xs-1 text-center';
        const messageDiv = this.props.hideIcon ? 'col-xs-11' : 'col-xs-10';
        const sectionStyle = this.props.className ? 'user-notification-parent ' + this.props.className : 'user-notification-parent container'
        const upperWrapCopyStyle = this.props.className ? 'container user-notification' : 'user-notification';
        const wrapCopyStyle = this.props.wrapCopy ? 'container' : '';
        const closeIconStyle = this.props.wrapCopy || this.props.isCountdown ? 'hidden' : 'col-xs-1 text-right';
        const closeIconStyleFloat = this.props.wrapCopy ? 'text-right pull-right' : 'hidden';
        const buttonStyle = ClassNames('btn btn-success btn-lg done-button', this.props.buttonClassName);
        const button = this.props.showButton
            ? <div className="row col-xs-12"><button className={buttonStyle} type="button" id={this.props.id + '-button'} onClick={this.props.onClickButton}>{this.props.buttonText}</button></div>
            : null;
        const closeIcon = this.props.onClick
            ? <a id={this.props.id + '-info-expand'} className="user-notification-close" onClick={this.props.onClick}>
                <i className="icon icon-cancel-circled"></i></a>
            : null;

        return !this.props.isHidden ?
            (<section className={sectionStyle} ref="userNotification" key={`${this.props.id}UserNotification`}>
                <div className={upperWrapCopyStyle}>
                    <div className={closeIconStyleFloat}>
                        {closeIcon}
                    </div>
                    <div className={wrapCopyStyle}>
                        <div className="row">
                            <div className={iconStyle}>
                                <i className="glyphicon glyphicon-warning-sign"></i>
                            </div>
                            <div className={messageDiv}>
                                <div className={this.props.messageClassName}>
                                    {this.getMessageHeader()}
                                </div>
                            </div>
                            <div className={closeIconStyle}>
                                {closeIcon}
                            </div>
                        </div>
                        {this.getMessageBody()}
                        {button}
                        {this.props.showBackButton && (
                        <div className="user-notification-back-section">
                              <a ref="backLink" onClick={this.props.onClickBackButton}><i className="fa fa-pencil"></i> Go back</a>
                        </div>
                        )}
                    </div>
                </div>
            </section>)
            : null;
    }
}
);

module.exports = UserNotification;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/UserNotification.jsx